export const getACMHeaders = projectScope => {
  const headers = {};
  if (projectScope && projectScope.length) {
    headers['x-ads-acm-scopes'] = projectScope.join(',');
  }
  headers['x-ads-acm-check-groups'] = 'true';

  return headers;
};
